import { initCartDrawerShopperListAll } from "./components/cartDrawerShopperList";
import { initDetailsAccordionAll } from "./components/detailsAccordion";
import { initProductMediaGalleryAll } from "./components/productMediaGallery";
import { initProductQuantityAll } from "./components/productQuantity";
import { initTopMainVisualAll } from "./components/topMainVisual";
import { initTopProductListBirdsAll } from "./components/topProductListBirds";
import { initViewMoreRotateAll } from "./components/viewMoreRotate";

function onReady(): void {
  initTopMainVisualAll();
  initTopProductListBirdsAll();
  initViewMoreRotateAll();
  initDetailsAccordionAll();
  initProductMediaGalleryAll();
  initProductQuantityAll();
  initCartDrawerShopperListAll();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", onReady);
} else {
  onReady();
}

document.addEventListener("shopify:section:load", onReady);
document.addEventListener("header-menu:mounted", () => {
  const root = document.querySelector("[data-js-header-menu-columns]");
  if (root) initDetailsAccordionAll(root);
});
document.addEventListener("footer-menu:mounted", () => {
  const root = document.querySelector("[data-js-footer-menu-columns]");
  if (root) initDetailsAccordionAll(root);
});
document.addEventListener("cart-drawer:content-updated", () => {
  initCartDrawerShopperListAll();
});
